import type { Pessoa } from '@sheafyield/dominio';
import type { FiltroDePessoas } from '../dados/consultas.js';

export const ROTULO_DO_FILTRO: Record<FiltroDePessoas, string> = {
  todos: 'Todos',
  revisitas: 'Revisitas',
  estudos: 'Estudos',
  interessados: 'Interessados',
};

/** Lista e ficha falam o mesmo vocabulário; estado da pessoa não se confunde
 *  com resultado de visita, que conserva o dicionário de Registrar. */
export const ROTULO_DO_STATUS: Record<Pessoa['status'], string> = {
  interessado: 'Interessada',
  revisita: 'Revisita',
  estudo: 'Estudo',
  nao_visitar: 'Não visitar',
};
